/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:inquiryLottCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di inquiry lotto richiesta carte
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('InquiryLottCartaDebitoIntSrvc', [
    '$http',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * numero delle carte richiesto per la richiesta
       */
      this.currentNumeroCarte;

      /**
       * prodotto selezionato.
       */
      this.currentProdotto;

      /**
       * elenco dei prodotti.
       */
      this.elencoProdotto;

      /**
       * elenco degli stati lotto.
       */
      this.elencoStatiLotto;
      
      /**
       * elenco degli stati lotto visibile nel filtro.
       */
      this.elencoStatiLottoFiltro;
      
      /**
       * indirizzo spedizione.
       */
      this.currentIndirizzoSpedizione;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: false };

      /**
       * Riferimento interno
       */
      var self = this;

      this.resetData = function () {
        self.currentNumeroCarte = null;
        self.currentProdotto = null;
      };
      
      /**
       * 
       * Inizializzazione del filtro ricerca
       */    
      this.filtro = {
    		'dataDa' : new Date(),
      		'dataA' : new Date(),
      		'prodotto' : null,
      		'stato' : null
      };
      
      this.resetFiltro = function () {
    	  var d = new Date(Date.now());
          
    		  self.filtro = {
    		    		'dataDa' : new Date(d.setMonth(d.getMonth()-1 , d.getDate())),
    		      		'dataA' : new Date(),
    		      		'prodotto' : null,
    		      		'stato' : null
    		      };
      }

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione del pulsante "richiedi". Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediAbilitato = function () {
        return false;
      };

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.richiediVisibile = this.defaultRichiediVisibile;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.richiediAbilitato = this.defaultRichiediAbilitato;


      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:ReqLottCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDominio = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseCerca
       * @methodOf cbl.cartadebitoint.wa.directive:InquiryLottCartaDebitoIntSrvc
       * @description Effettua la chiamata per cercare i lotti carte 
       * @return {Promise} - Ritorna una promise contenente la lista dei lotti
       */
      this.promiseCerca = function (filtro) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.REQ_LOTT.CERCA_LOTTI,              
          data: filtro
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/inquiryLottCartaDebitoInt/inquiryLottCartaDebitoIntSrvc.js
// module id = 17
// module chunks = 0